/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptsControllerFindOneQueryResponse, PromptsControllerFindOnePathParams, PromptsControllerFindOne401, PromptsControllerFindOne403, PromptsControllerFindOne404 } from "../../models/promptsController/PromptsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { promptsControllerFindOne } from "../../clients/promptsService/promptsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const promptsControllerFindOneQueryKey = (id: PromptsControllerFindOnePathParams["id"]) => [{
  url: '/api/v1/prompts/:id',
  params: {
    id: id
  }
}] as const;
export type PromptsControllerFindOneQueryKey = ReturnType<typeof promptsControllerFindOneQueryKey>;
export function promptsControllerFindOneQueryOptions(id: PromptsControllerFindOnePathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = promptsControllerFindOneQueryKey(id);
  return queryOptions<PromptsControllerFindOneQueryResponse, ResponseErrorConfig<PromptsControllerFindOne401 | PromptsControllerFindOne403 | PromptsControllerFindOne404>, PromptsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return promptsControllerFindOne(id, config);
    }
  });
}

/**
 * @summary Get a prompt by ID
 * {@link /api/v1/prompts/:id}
 */
export function usePromptsControllerFindOne<TData = PromptsControllerFindOneQueryResponse, TQueryData = PromptsControllerFindOneQueryResponse, TQueryKey extends QueryKey = PromptsControllerFindOneQueryKey>(id: PromptsControllerFindOnePathParams["id"], options: {
  query?: Partial<QueryObserverOptions<PromptsControllerFindOneQueryResponse, ResponseErrorConfig<PromptsControllerFindOne401 | PromptsControllerFindOne403 | PromptsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? promptsControllerFindOneQueryKey(id);
  const query = useQuery({
    ...promptsControllerFindOneQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PromptsControllerFindOne401 | PromptsControllerFindOne403 | PromptsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}